import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";
import { AuthService } from '../../service/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoginService } from '../loginone/login.service';
import { ToastrService } from 'ngx-toastr';

@Component({
   selector: 'ms-register-session',
   templateUrl: './register-component.html',
   styleUrls: ['./register-component.scss'],
   encapsulation: ViewEncapsulation.None,
})
export class RegisterComponent implements OnInit {

   ngForm: FormGroup;
   emailPattern: string = "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$";

   constructor(

   ) { }

   ngOnInit() {

   }


}